import Screen from './screen';
import Screen1 from './screen1';

export default {
    Screen,
    Screen1
};
